export const queue = {
  input: {
    timeout: {
      label: 'Время ожидания в очереди'
    },

    type: {
      label: 'Метод распределения'
    },

    contact_methods: {
      label: 'Контакт методы'
    },

    contact_groups: {
      label: 'Группы'
    }
  },

  state: {
    init: {
      description:
        'Позволяет направить вызов на группу операторов. Просмотреть и настроить список операторов можно в разделе'
    },
    add_group: {
      title: 'Добавить группу в очередь'
    },

    ['add-method']: {
      title: 'Добавить контакт метод в очередь',
      description: `Добавить новый контакт метод и группу вы можете в личном кабинете, в разделе`
    }
  }
};
